import React from 'react';
import { SearchContainer, SearchLabel, SearchWrapper, SearchInput as StyledSearchInput } from './styles';
var SearchInput = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange;
    return (React.createElement(SearchContainer, null,
        React.createElement(SearchLabel, null, label),
        React.createElement(SearchWrapper, null,
            React.createElement(StyledSearchInput, { value: value, placeholder: placeholder, onChange: function (e) { return onChange(e.target.value); } }))));
};
export default SearchInput;
